import { defineStore } from "pinia";


export const useNotificationStore = defineStore('notificationStore',{
    state:() => ({
        notification:{
            flag: false,
            title: '',
            msg: '',
            icon: '',
            timeout: 4000,
            color: ''
        }
    }),

    actions:{
        setNotification(title, msg, icon, color) {
            this.notification = {
                flag: true,
                title,
                msg,
                icon,
                timeout: 4000,
                color,
            };
        }
    }


});